var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('Head'),_c('banner',{attrs:{"banner":_vm.slidePic,"slide":_vm.slide}}),_c('div',{staticClass:"page-wrapper"},[(!!_vm.thispage)?_c('Content',{attrs:{"pagecontent":_vm.thispage.items}}):_vm._e()],1),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }